import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    context: 'event',
    path: 'id',
    viewPath: props.viewPath,
  })

  return {
    variables: { id },
    pause: !id,
  }
}
